/**
 * http请求公共基础类
 */
import axios from 'axios'
import ResultCode from './result-code'
import { Toast } from 'vant'
import APIS from './api'
import store from '../../store/index'
import router from '@/router'
import utils from '@/libs/utils'

let baseURL = APIS.HTTP_URL

function clearUserInfo () {
  store.commit('User/setUserInfo', null)
  store.commit('User/setUserCenter', null)
  store.commit('User/setShowLogin', true)
  if (router.history && router.history.current && router.history.current.path === '/home') {
    router.go(0)
    return
  }

  router.replace('/')
}

/**
 * 用户类型
 * @type {{user: number}}
 */
const USER_TYPE = {
  user: 3
}

/**
 * 网络请求方法
 * @param method
 * @param url
 * @param params
 * @param config
 * @returns {Promise<any>}
 */
function apiAxios (method, url, params, config) {
  let token
  if (store.state.User.userInfo) {
    let userInfo = store.state.User.userInfo
    token = userInfo.token
  }
  if (!params) {
    params = {}
  }
  params.channel = utils.getChannel()
  params.channelCode = utils.getChannel()
  let requestConfig = {
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: baseURL,
    withCredentials: false,
    responseType: 'json',
    timeout: 30000,
    transformRequest: [function (data) {
      if (!data) {
        data = {}
      }
      data.channel = utils.getChannel()
      data.channelCode = utils.getChannel()
      data.usertype = USER_TYPE.user
      return JSON.stringify(data)
    }],
    headers: {
      'Content-Type': 'application/json',
      'token': token
    }
  }

  // 这个是为了兼容之前写的不知道改了什么配置存在的
  if (config) {
    // 对象合并
    requestConfig = Object.assign(requestConfig, config)
  }

  return new Promise(function (resolve, reject) {
    axios(requestConfig).then(
      (res) => {
        let code = res.data.code
        if (res.data) {
          if (ResultCode.RC_SUCCESS === code ||
            ResultCode.RC_PAY_SUCCESS === code
          ) {
            // {
            //   code:0,
            //   msg:'',
            //   data:{}
            // }
            // resolve(res.data.data)
            resolve(res.data)
            return
          }

          // 走都这里业务失败提示msg 当然可能msg 空的。
          if (res.data.msg && !requestConfig.ignoreError) {
            Toast(res.data.msg)
            // return;
          } else {
            // Toast('未知错误，请联系客服');
          }
          if (ResultCode.RC_CHANNEL_ERR === code) {
            router.replace('ErrPage')
            return
          }

          // 重新登录
          if (ResultCode.RC_LOGIN_OUT === code || ResultCode.RC_LOGIN_OUT + '' === code || ResultCode.RC_TOKEN_ERR === code || res.data.msg === 'access_token非法或者过期!') {
            clearUserInfo()
          }
          console.info(' res.data is  ', res.data)
          reject(res.data)
          return
        }
        console.error(' res.data is empty ')
        reject(res.data)
        Toast('数据格式异常，请联系客服')
      }
    ).catch((err) => {
      reject(err)
      console.log('err', err)
    }
    )
  })
}

/**
 * 为了兼容现有模式post
 * 返回在vue模板中的调用接口
 */
export default {
  all: axios.all,
  spread: axios.spread,
  get: function (url, params, config) {
    return apiAxios('GET', url, params, config)
  },
  post: function (url, params, config) {
    return apiAxios('POST', url, params, config)
  },
  put: function (url, params, config) {
    return apiAxios('PUT', url, params, config)
  },
  delete: function (url, params, config) {
    return apiAxios('DELETE', url, params, config)
  }
}



// WEBPACK FOOTER //
// ./src/libs/request/http.js